import { z } from "zod";

export const selectionSourceSchema = z.enum(["preAuth", "postAuth", "system"]);

export type SelectionSource = z.infer<typeof selectionSourceSchema>;
